import Reveal from './Reveal';
import siteData from '../siteData.json';
import { FaChevronUp, FaLinkedinIn, FaFacebookF, FaInstagram, FaTwitter, FaPinterest, FaYoutube, FaYelp } from 'react-icons/fa';
import { handleHashNav } from '../utils/utils';

const socialIcons = {
  linkedin: <FaLinkedinIn className="icon" />,
  facebook: <FaFacebookF className="icon" />,
  instagram: <FaInstagram className="icon" />,
  twitter: <FaTwitter className="icon" />,
  pinterest: <FaPinterest className="icon" />,
  youtube: <FaYoutube className="icon" />,
  yelp: <FaYelp className="icon" />
};

const year = new Date().getFullYear();

function Footer() {
  return (
    <footer className="footer">
      <Reveal direction="right" className="left">
        <p>&copy; {year} {siteData.company.name}</p>
        <span className="vertical">|</span>
        <p>All Rights Reserved</p>
        <span className="vertical">|</span>
        <a className="link" href="/privacypolicy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
      </Reveal>
      <Reveal direction="left" className="right">
        {siteData.socials.map((social, i) => (
          <a href={social.url} target="_blank" rel="noopener noreferrer" key={i}>
            <div>{socialIcons[social.name]}</div>
          </a>
        ))}
        {siteData.socials.length > 0 && <span className="vertical">|</span>}
        <a href="/#Hero" onClick={handleHashNav("Hero")}>
          <div className="backtotop"><FaChevronUp className="icon" /></div>
        </a>
      </Reveal>
    </footer>
  );
}

export default Footer;